import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Login from "./Components/LogIn/LogIn";

const LoggedOut = () => (
  <Switch>
    <Route path="/login" component={Login} />
    <Route path="/" render={() => <Redirect to="/login" />} />
  </Switch>
);

export default LoggedOut;
